import { atom } from '@reatom/framework'

import type { tradeApi } from '@blade/socket-types'

export const feeConfigAtom = atom<tradeApi.FeeConfig | undefined>(
  undefined,
  'feeConfigAtom',
)
